import { Navigate, useSearchParams } from 'react-router-dom';

import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';

export function SearchRedirect() {
  const locale = useLocale();
  const [params] = useSearchParams();
  const q = (params.get('term') ?? params.get('q') ?? '').trim();
  return <Navigate to={routes.search(locale, q || undefined)} replace />;
}
